module.exports = __webpack_public_path__ + "img/background-coins.18d5a59a.png";